import React from 'react';
import {Link} from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';

const LinkEditarButtonVisita = ({record}) => {
    return (
        <Link to={`/ContratacionEncuadre/${record.id}/1`}>
            <div title={''}
                 style={{display: 'flex', flexWrap: 'nowrap', alignItems: 'center', color: '#123B80'}}
            >
                <EditIcon style={{fontSize: 20}}/> Editar
            </div>
        </Link>
    );
}

LinkEditarButtonVisita.defaultProps = {
    source: '',
    addLabel: true,
};

export default LinkEditarButtonVisita;